import { render, staticRenderFns } from "./EventDesc.vue?vue&type=template&id=9303a660&scoped=true"
import script from "./EventDesc.vue?vue&type=script&lang=js"
export * from "./EventDesc.vue?vue&type=script&lang=js"
import style0 from "./EventDesc.vue?vue&type=style&index=0&id=9303a660&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9303a660",
  null
  
)

export default component.exports